<template>
	<div class="orders-page">
		<div v-if="orderSelected === null">
			<div>
				<div class="left">
					<h1>{{ $t("ordersName") }}</h1>
				</div>
				<div class="right">
					<a href="/customer/new_order" class="notification-action custom-notification-action">{{
						$t("newOrderName") }}</a>
				</div>
			</div>
			<br clear="all" />
			<div>
				<div class="left">
					<h3>
						<i v-html="$t('ordersHistoryMessage')"></i>
					</h3>
				</div>

				<div class="right d-flex align-items-center">
					<span class="status-background background-will-expire">
						{{ $t("orderStatus_N") }}
					</span>
					&nbsp;&nbsp;
					<font-awesome-icon icon="long-arrow-alt-right" size="2x" class="px-1" />
					&nbsp;&nbsp;
					<span class="status-background background-production">
						{{ $t("orderStatus_PR") }}
					</span>
					&nbsp;&nbsp;
					<font-awesome-icon icon="long-arrow-alt-right" size="2x" class="px-1" />&nbsp;&nbsp;
					<span class="status-background background-active">
						{{ $t("orderStatus_V") }}
					</span>
				</div>
			</div>
			<br clear="all" />
			<div v-if="this.pendingOrders !== null && this.pendingOrders.length > 0" class="container-alb moverflow">
				<div class="table-header-wrapper">
					<div class="left">
						<h3 class="table-title">{{ $t("pendingOrdersTitle") }}</h3>
					</div>
					<!-- <p>{{ $t("pendingOrdersMessage", {noOrders: this.pendingOrders.length}) }}</p> -->
				</div>

				<orders-table-desktop @change="sortBy" @click="selectPendingOrderMobile" :companyOrders="pendingOrders" :userRole="this.userRole"
					:pending="true" :company="this.customer" />
				<!-- </div> -->
			</div>

			<div class="container-alb moverflow">
				<div class="table-header-wrapper">
					<div class="left">
						<h3 class="table-title">{{ $t("ordersHistoryTitle") }}</h3>
					</div>
					<div class="right">
						<date-range class="invoices-filter" @close="periodFilterChanged" :time="this.filters.period"
							:noRanges="false" :single="false" />
					</div>
				</div>
				<div class="loading" v-if="this.orders === null">
					<img src="@/assets/images/loading.gif" />
				</div>

				<orders-table-desktop v-if="this.ordersCount > 0" @change="sortBy" @click="selectPendingOrderMobile"
					:companyOrders="this.orders" :pending="false" :company="this.customer" :userRole="this.userRole"/>
				<div class="pagination-wrapper border-box" v-if="this.ordersCount > 0">
					<b-pagination v-model="currentPage" :total-rows="ordersCount" :per-page="perPage"
						aria-controls="orders-table" size="sm"></b-pagination>
				</div>
				<div class="error-wrapper border-box" v-else>
					<p>{{ $t("noOrdersMessage") }}</p>
				</div>

			</div>

			<div v-if="this.replacementOrders !== null && this.replacementOrders.length > 0"
				class="container-alb moverflow">
				<div class="table-header-wrapper">
					<div class="left">
						<h3 class="table-title">{{ $t("replacementOrdersTitle") }}</h3>
					</div>
				</div>

				<OrdersREPLTableDesktop @change="sortBy" :companyOrders="this.replacementOrders" :deliveryAddresses="this.deliveryAddresses" />
			</div>
		</div>
		<div v-else>
			<h3 class="return">
				<a href="#" @click="orderSelected = null">
					<font-awesome-icon icon="chevron-left" />
					<span>{{ $t("backButtonLabel") }}</span>
				</a>
			</h3>
			<OrderDetails :orderId="this.orderSelected.id" :orderType="this.orderSelected.type" :customer="this.customer"
				:deliveryAddresses="this.deliveryAddresses" @click="selectPendingOrderMobile"
				:simulation="this.orderSelected.simulation" />
		</div>
		<!-- <div id="modal_popup_loading" class="modal-popup">
			<div class="modal-popup-content">
				<img src="@/assets/images/loading.gif" />
				<p v-html="$t('loadingPopupMessage')"></p>
			</div>
		</div> -->
		<div id="modal_popup_info" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_info', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p v-if="this.orderError" v-html="$t('orderError_' + this.orderError.code)"></p>

				<div v-if="!this.orderError">
					<p v-if="this.action === 'cancel'" v-html="$t('orderDeleteSuccess')"></p>

					<p v-if="this.action === 'pay'" v-html="$t('orderPayRedirect')"></p>
					<p v-if="this.action === 'paylater'" v-html="$t('orderPayLater')"></p>
				</div>
			</div>
		</div>
		<div id="modal_popup_confirmOrderDelete" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_confirmOrderDelete', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p v-html="$t('confirmOrderDelete')"></p>
				<div class="buttons">
					<a href="#" class="yesButton" @click="cancelOrder(orderForAction)">
						{{ $t("notificationsChooseOptionYes") }}
					</a>
					<a href="#" class="noButton" @click="showModalPopup('modal_popup_confirmOrderDelete', false)">{{
						$t("notificationsChooseOptionNo") }}</a>
				</div>
			</div>
		</div>
		<div id="modal_popup_orderPayStatus" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_orderPayStatus', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p v-html="$t('orderPaymentStatusText', {
					data: $t('orderPaymentStatus_' + orderPaymentStatus)
				})
					"></p>
			</div>
		</div>
		<iris-pay-modal-popup v-if="customer" :order="orderForAction" :customerId="customer.company_id" />
	</div>
</template>

<script>
import Cookies from "js-cookie";

import httpServiceCompany from "@/http/http-user.js";
import httpServiceCustomer from "@/http/http-customer.js";
import utils from "@/plugins/utils.js";
import OrderDetails from "@/components/company/customer/OrderDetails.vue";
import OrdersTableDesktop from "@/components/company/customer/OrdersTableDesktop.vue";
import OrdersREPLTableDesktop from "@/components/company/customer/OrdersREPLTableDesktop.vue";
import DateRange from "@/components/DateRange.vue";
import { BPagination } from "bootstrap-vue";
import moment from "moment";
import IrisPayModalPopup from "@/components/company/IrisPayModalPopup.vue";

export default {
	props: {
		customer: Object,
		userRole: String
	},
	components: {
		OrderDetails,
		DateRange,
		OrdersTableDesktop,
		OrdersREPLTableDesktop,
		IrisPayModalPopup,
		"b-pagination": BPagination
	},
	data() {
		return {
			customerBeneficiaries: null,
			orderSelected: null,
			orders: null,
			pendingOrders: null,
			replacementOrders: null,
			ordersCount: 0,
			sortField: "order_date",
			sortDirection: "desc",
			reverse: false,
			window: {
				width: 0,
				height: 0
			},
			filters: {
				product: "dejun",
				invoiceStatus: null,
				period: [moment().subtract(3, "month"), moment()]
			},
			detailsMobile: false,
			orderSelectedMobile: null,
			pendingOrderSelectedMobile: null,
			perPage: 10,
			currentPage: 1,
			orderError: null,
			action: null,
			orderForAction: null,
			orderPaymentStatus: "",
			deliveryAddresses: null
		};
	},
	methods: {
		sortBy(sortFieldChange, sortDirectionChange, pendingChange) {
			this.sortField = sortFieldChange;

			this.sortDirection = sortDirectionChange;
			this.getCustomerOrders(pendingChange ? "pending" : "");
		},
		getCustomerOrders(status = null, type = null) {
			var ordersData =
				"?start_date=" +
				moment(this.filters.period[0]).format("YYYYMMDD") +
				"&end_date=" +
				moment(this.filters.period[1]).format("YYYYMMDD");
			if (status === "pending") {
				ordersData += "&status=P,N,V2,PR,PV,R";
			}
			if (type === "REPL") {
				ordersData += "&type=" + type +
					"&per_page=10000" +
					"&page=1";
			} else {
				ordersData +=
					"&per_page=" +
					this.perPage +
					"&page=" +
					this.currentPage;
			}
			ordersData +=
				"&sort=" +
				this.sortDirection;
			if (this.sortDirection === "desc") {
				ordersData += "&desc=" + this.sortField;
			} else {
				ordersData += "&asc=" + this.sortField;
			}
			httpServiceCustomer.customerService
				.searchOrders(
					ordersData,
					this.customer.company_id,
					Cookies.get("token")
				)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch(function () {
					// handle success
					// this.showModalPopup("modal_popup_loading", false);
				})
				.then(response => {
					if (response.status == 200) {
						if (status === "pending") {
							this.pendingOrders = response.data.results;
						} else if (type === "REPL") {
							this.replacementOrders = response.data.results;
						} else {
							this.orders = response.data.results;
							this.ordersCount = response.headers["x-up-count"];
						}
					} else if (response.status == 400 || response.status == 403) {
						this.orderError = {
							code: response.data,
							description: "Error fetching orders"
						};
					} else {
						this.orderError = { description: response.description };
					}
					// this.showModalPopup("modal_popup_loading", false);
				});
		},
		selectPendingOrderMobile(order, action) {
			this.action = action;
			if (action === "cancel") {
				this.showModalPopup("modal_popup_confirmOrderDelete", true);
				this.orderForAction = order;
			} else if (action === "details") {
				// this.showModalPopup("modal_popup_loading", true);
				this.orderSelected = order;
			} else if (action === "pay") {
				this.showModalPopup("modal_popup_confirmOrderPay", true);
				this.orderForAction = order;
			} else if (action === "paylater") {
				this.payLater(order);
				this.orderForAction = order;
			}
		},
		periodFilterChanged(value) {
			this.filters.period = value;
			this.orders = null;
			this.getCustomerOrders();
			this.getCustomerOrders(null, "REPL");
		},
		payLater(order) {
			// cancel order
			// this.showModalPopup("modal_popup_loading", true);
			let proformDetails = {
				orderId: order.id,
				manual: true
			};
			httpServiceCustomer.customerService
				.payOrderLater(
					this.customer.company_id,
					proformDetails,
					Cookies.get("token")
				)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch(function () {
					// handle success
					// this.showModalPopup("modal_popup_loading", false);
				})
				.then(response => {
					if (response.status == 200) {
						this.payLaterSuccess = true;
					} else if (response.status == 400 || response.status == 403) {
						this.orderError = {
							code: "PAY_LATER"
						};
					}
					// return null;
					this.showModalPopup("modal_popup_info", true);
					// this.showModalPopup("modal_popup_loading", false);
					this.orderForAction = null;
				});
		},
		cancelOrder(order) {
			// cancel order
			this.showModalPopup("modal_popup_loading", true);
			httpServiceCustomer.customerService
				.cancelOrder(this.customer.company_id, order, Cookies.get("token"))
				.then(function (response) {
					// handle success
					return response;
				})
				.catch(function () {
					// handle success
					this.showModalPopup("modal_popup_loading", false);
				})
				.then(response => {
					if (response.status == 200) {
						this.getCustomerOrders();
						this.getCustomerOrders("pending");
					} else if (response.status == 400 || response.status == 403) {
						this.orderError = {
							code: "DELETE",
							description: "Error deleting order"
						};
						// return null;
					} else {
						this.orderError = {
							code: "DELETE",
							description: response.description
						};
						// return null;
					}
					this.showModalPopup("modal_popup_info", true);
					this.showModalPopup("modal_popup_loading", false);
					this.showModalPopup("modal_popup_confirmOrderDelete", false);
					this.orderForAction = null;
				});
		},
		getPaymentInfo(irisOrderId) {
			httpServiceCustomer.customerService
				.getOrderPaymentData(
					this.customer.company_id,
					irisOrderId,
					Cookies.get("token")
				)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch(function () {
					// handle success
				})
				.then(response => {
					if (response.status == 200) {
						this.orderPaymentStatus = response.data.resp.orderStatus;
						this.showModalPopup("modal_popup_orderPayStatus", true);
					} else if (response.status == 400 || response.status == 403) {
						this.orderPaymentStatus = "400";
					} else {
						this.orderPaymentStatus = "500";
					}
					this.showModalPopup("modal_popup_loading", false);
				});
		},
		showModalPopup(elementId, show) {
			if (show) {
				document.getElementById(elementId).style.visibility = "visible";
			} else {
				document.getElementById(elementId).style.visibility = "hidden";
			}
		},
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
		getDeliveryAddreses() {
			var formData = "?per_page=" + 10000 + "&page=" + 1;

			httpServiceCompany.userService
				.getAddressPoints(
					this.customer.company_id,
					formData,
					Cookies.get("token")
				)
				.then(function (response) {
					return response;
				})
				.catch(error => {
					this.deliveryAddresses = null;
				})
				.then(response => {
					if (response.status == 200) {
						this.deliveryAddresses = response.data.results;
					} else if (response.status == 400 || response.status == 403) {
						this.deliveryAddresses = null;
					}
				});
		}
	},
	created() {
		this.getDeliveryAddreses();
		this.getCustomerOrders();
		this.getCustomerOrders("pending");
		this.getCustomerOrders(null, "REPL");
		window.addEventListener("resize", this.handleResize);
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener("resize", this.handleResize);
	},
	mounted() {

		this.token = Cookies.get("token");
		let orderId = utils.getUrlParam("order_id");
		if (orderId) {
			this.orderSelected = { id: orderId, type: "NEWCR" };
		}
		let initiatingPartyRefId = utils.getUrlParam("orderId");
		if (initiatingPartyRefId) {
			let orderIdPayment = utils.getUrlParam("orderId");
			this.getPaymentInfo(orderIdPayment);
		}
	},
	watch: {
		currentPage: function () {
			this.getCustomerOrders();
		}
	}
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.page-link {
	color: #4a4a4a;
}

.page-link:hover {
	color: #4e5b59;
}

.page-item.active .page-link {
	background-color: #4e5b59 !important;
	border-color: #4e5b59 !important;
}
</style>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.invoices-filter .reportrange-text {
	height: 27px;
	font-size: 13px;
	padding: 3px 10px;
	border: none !important;
	color: #585858;
	background: #f1f1f1;
}

@media (max-width: 768px) {
	.invoices-filter .vue-daterange-picker {
		width: 100%;
	}

	.invoices-filter .mobile-icon {
		float: right;
	}
}
</style>
